import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import Box from 'common/components/Box';
import Text from 'common/components/Text';
import Heading from 'common/components/Heading';
import Button from 'common/components/Button';
import Card from 'common/components/Card';
import FeatureBlock from 'common/components/FeatureBlock';
import Container from 'common/components/UI/Container';
import GatsbyImage from 'common/components/GatsbyImage';
import VisitorSectionWrapper, { SectionObject, FeatureWrapper } from './visitor.style';

const VisitorSection = ({
  title,
  description,
  textArea,
  imageWrapper,
  btnStyle,
}) => {
  const data = useStaticQuery(graphql`
    query {
      image1: file(relativePath: { eq: "image/saas/visitor_bg.png" }) {
        childImageSharp {
          gatsbyImageData(
            width: 1017
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
      image2: file(relativePath: { eq: "image/saas/reporting-interface.png" }) {
        childImageSharp {
          gatsbyImageData(
            width: 1031
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `);

  return (
    <VisitorSectionWrapper id="visitorSection">
      <SectionObject>
        <Card className="objectWrapper" {...imageWrapper}>
          <Zoom>
            <GatsbyImage
              src={
                (data.image1 !== null) | undefined
                  ? data.image1.childImageSharp.gatsbyImageData
                  : {}
              }
              alt="BgImage"
            />
          </Zoom>
          <Card className="dashboardWrapper" {...imageWrapper}>
            <Fade left>
              <GatsbyImage
                src={
                  (data.image2 !== null) | undefined
                    ? data.image2.childImageSharp.gatsbyImageData
                    : {}
                }
                alt="Reporting Interface"
              />
            </Fade>
          </Card>
        </Card>
      </SectionObject>
      
      <Container>
        <FeatureWrapper>
        <Box {...textArea}>
          <Heading
            content="Powerful DICOM & Reporting Capabilities"
            {...title}
          />
          <FeatureBlock
              key={`app-feature--key1`}
              iconPosition="left"
              icon={<i className="flaticon-bitcoin"></i>}
              title={<Heading as="h3" content="Zero Footprint Viewer" />}
              description={<Text content="Blazing fast Web based viewer loads even think slice scans within minutes " />}
            />
          <FeatureBlock
              key={`app-feature--key2`}
              iconPosition="left"
              icon={<i className="flaticon-bitcoin"></i>}
              title={<Heading as="h3" content="Open Study in your favourite viewer" />}
              description={<Text content="Download and open full size DICOMs on your favourite viewer (eg. Radiant, Weasis) directly" />}
            />
          <FeatureBlock
              key={`app-feature--key3`}
              iconPosition="left"
              icon={<i className="flaticon-bitcoin"></i>}
              title={<Heading as="h3" content="Fast Report Authoring" />}
              description={<Text content="Full fledged WSYIWYG editor helps create detailed report with formatting, tables & images. Modality specific templates and text expansion reduces reporting time" />}
            />
        </Box>
        </FeatureWrapper>
      </Container>
    </VisitorSectionWrapper>
  );
};

VisitorSection.propTypes = {
  title: PropTypes.object,
  description: PropTypes.object,
  btnStyle: PropTypes.object,
};

VisitorSection.defaultProps = {
  textArea: {
    width: ['100%', '100%', '45%'],
    ml: [0, 0, '58%'],
  },
  imageWrapper: {
    boxShadow: 'none',
  },
  title: {
    fontSize: ['20px', '26px', '26px', '36px', '48px'],
    fontWeight: '400',
    color: '#0f2137',
    letterSpacing: '-0.010em',
    mb: '20px',
    maxWidth: ['100%', '100%', '100%', '440px', '440px'],
    lineHeight: '1.5',
  },
  description: {
    fontSize: '16px',
    color: '#343d48cc',
    lineHeight: '1.75',
    mb: '33px',
    maxWidth: ['100%', '100%', '100%', '440px', '440px'],
  },
  btnStyle: {
    minWidth: '156px',
    fontSize: '14px',
    fontWeight: '500',
    color: '#fff',
    borderRadius: '4px',
    pl: '22px',
    pr: '22px',
    colors: 'primaryWithBg',
  },
};

export default VisitorSection;
